import { Spacing } from '@persona-id/design-tokens';
import { formatPhoneNumber } from 'react-phone-number-input';
import styled from 'styled-components';

import ChecksTable from 'dashboard/components/ChecksTable';
import { VerificationDetailProps } from 'dashboard/components/VerificationDetail/types';
import { formatDate } from 'dashboard/lib/utils/formatters';
import { VerificationDatabaseStandard } from 'dashboard/models/verification';
import Attribute, { AttributeGrid } from 'design-system/components/Attribute';
import { VerificationStatus } from 'lib/verification';

const StyledAttributeGrid = styled(AttributeGrid)`
  padding: 0 ${Spacing[4]} ${Spacing[2]};
`;

interface DatabaseStandardVerificationProps extends VerificationDetailProps {
  verification: VerificationDatabaseStandard;
}

const DatabaseStandardVerification = ({ verification }: DatabaseStandardVerificationProps) => {
  const {
    'name-first': nameFirst,
    'name-middle': nameMiddle,
    'name-last': nameLast,
    birthdate,
    'email-address': emailAddress,
    'address-street-1': addressStreet1,
    'address-street-2': addressStreet2,
    'address-city': addressCity,
    'address-subdivision': addressSubdivision,
    'address-postal-code': addressPostalCode,
    'phone-number': phoneNumber,
    status,
    'redacted-at': redactedAt,
  } = verification.attributes;

  const isRedacted = redactedAt != null;

  const hasBeenSubmitted = status !== VerificationStatus.Initiated;

  const checks = verification.attributes.checks;
  const nameFull = [nameFirst, nameMiddle, nameLast].filter(Boolean).join(' ');

  return (
    <>
      {hasBeenSubmitted && checks && checks.length > 0 && status ? (
        <ChecksTable checks={checks} verification={verification} />
      ) : (
        <StyledAttributeGrid>
          <Attribute label='Full name' value={nameFull} redacted={isRedacted} />
          <Attribute label='Birthdate' value={formatDate(birthdate)} redacted={isRedacted} />
          <Attribute
            label='Phone Number'
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            value={formatPhoneNumber(phoneNumber)}
            redacted={isRedacted}
          />
          <Attribute label='Email address' value={emailAddress} redacted={isRedacted} />
          <Attribute
            label='Address'
            value={[
              addressStreet1,
              addressStreet2,
              [[addressCity, addressSubdivision].filter(Boolean).join(' '), addressPostalCode]
                .filter(Boolean)
                .join(', '),
            ]}
            redacted={isRedacted}
          />
        </StyledAttributeGrid>
      )}
    </>
  );
};

export default DatabaseStandardVerification;
